import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ModalCloseButtonComponent } from '../../modal-close-button/modal-close-button.component';

@Component({
  selector: 'app-confirm-customer-data-success-modal',
  templateUrl: './confirm-customer-data-success-modal.component.html',
  styleUrls: ['./confirm-customer-data-success-modal.component.scss'],
  imports: [MatIconModule, ModalCloseButtonComponent],
})
export class ConfirmCustomerDataSuccessModalComponent {
  constructor(
    private dialogRef: MatDialogRef<ConfirmCustomerDataSuccessModalComponent>
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }
}
